import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { ShippingMethod } from '~/types/GraphQL';

export default ($fetch: $Fetch) => {
  const getShippingMethodsByCountry = async () => $fetch<BFFResponse<ShippingMethod[]>>('/shippingMethods/byCountry');

  const getShippingMethod = async (id: string) => $fetch<BFFResponse<ShippingMethod>>(`/shippingMethods/${id}`);

  return {
    getShippingMethodsByCountry,
    getShippingMethod,
  };
};
